import { CardSize } from '../../../../utils/type'

export const sizeMap: { [key in CardSize]: { width: number; height: number } } = {
  [CardSize.Small]: {
    width: 30,
    height: 30,
  },
  [CardSize.Medium]: {
    width: 260,
    height: 225,
  },
  [CardSize.Large]: {
    width: 500,
    height: 500,
  },
}
